import { A11y, Keyboard, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { markRaw } from 'vue';
import { mapGetters } from 'vuex';
import 'swiper/css';
import { CMS_MARKET_RUNTIME } from '../../cms-config';
import { chartRecordsForMarket } from '../h2h-chart-data';
import { resolveHeadToHeadComponent } from '../h2h-component-resolver';

const EMPTY_RECORDS = Object.freeze([]);

export default {
  components: { Swiper, SwiperSlide },
  inject: { cmsRuntime: { from: CMS_MARKET_RUNTIME } },
  props: {
    settings: { type: Object, required: true },
    markets: { type: Array, default: () => [] },
    chartData: { type: Array, default: () => [] },
    showTagFilters: { type: Boolean, default: true },
  },
  data() {
    return {
      selectedTag: null,
      swiper: null,
      atStart: true,
      atEnd: false,
      locked: true,
      swiperModules: [A11y, Keyboard, Mousewheel],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    isScroll() {
      return this.settings.overflowBehavior !== 2;
    },
    showNavigation() {
      return this.isScroll && !this.isLayoutMobile && !this.locked && this.visibleTiles.length > 1;
    },
    tags() {
      return [
        ...new Set(
          (Array.isArray(this.settings.availableTags) ? this.settings.availableTags : []).filter(
            (tag) => typeof tag === 'string' && tag,
          ),
        ),
      ];
    },
    tiles() {
      return (Array.isArray(this.settings.tiles) ? this.settings.tiles : [])
        .filter((tile) => tile && tile.tileUUID)
        .map((tile) => ({
          ...tile,
          cardStyle: this.settings.cardStyle,
          priceDisplay: this.settings.priceDisplay,
          bottomStyle: this.settings.bottomStyle,
        }));
    },
    visibleTiles() {
      return this.tiles.filter(
        (tile) =>
          !this.showTagFilters ||
          this.selectedTag === null ||
          (Array.isArray(tile.tags) && tile.tags.includes(this.selectedTag)),
      );
    },
    histories() {
      const ids = new Set(
        this.chartData.filter((series) => series).map((series) => Number(series.marketId)),
      );
      return Object.fromEntries(
        [...ids].map((id) => [id, chartRecordsForMarket(this.chartData, id)]),
      );
    },
    tileComponent() {
      return resolveHeadToHeadComponent(this.settings.cardStyle);
    },
  },
  watch: {
    markets: {
      immediate: true,
      handler(markets) {
        this.cmsRuntime.seed(markets);
      },
    },
    showTagFilters(value) {
      if (!value) this.selectedTag = null;
    },
    tags(tags) {
      if (!tags.includes(this.selectedTag)) this.selectedTag = null;
    },
    visibleTiles() {
      this.$nextTick(() => {
        if (this.swiper && !this.swiper.destroyed) {
          this.swiper.update();
          this.swiper.slideTo(0, 0);
          this.syncNavigation(this.swiper);
        }
      });
    },
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = markRaw(swiper);
      this.syncNavigation(swiper);
    },
    syncNavigation(swiper) {
      this.atStart = swiper.isBeginning;
      this.atEnd = swiper.isEnd;
      this.locked = swiper.isLocked;
    },
    moveSlide(direction) {
      if (!this.swiper || this.swiper.destroyed) return;
      if (direction < 0) this.swiper.slidePrev();
      else this.swiper.slideNext();
    },
    records(tile) {
      return this.histories[Number(tile.market?.id)] || EMPTY_RECORDS;
    },
  },
};
